import axios from 'axios';

export default {
  // eslint-disable-next-line no-unused-vars
  async CREATE_budgetImport({ commit }, data) {
    const result = await axios.post('/import/budget', {
      userFileId: data.userFileId,
      movieId: data.movieId,
    });
    return result.data;
  },
  // eslint-disable-next-line no-unused-vars
  async CREATE_poImport({ commit }, data) {
    const result = await axios.post('/import/purchase-order', {
      userFileId: data.userFileId,
      movieId: data.movieId,
    });
    return result.data;
  },
};
